export enum LogoutReason {
    General = 'general',
    Inactivity = 'inactivity',
}

export const DOB_FORMAT = 'YYYY-MM-DD 00:00'

export const GENERIC_ERRORS = {
    REQUIRED_FIELD: 'required_field',
    SOMETHING_WENT_WRONG: 'UNKNOWN_ERROR',
    INVALID_ADDRESS: 'UNKNOWN_ERROR',
    INVALID_EMAIL: 'INVALID_EMAIL_ADDRESS',
}

export const TYPE_ERRORS = {
    ZIP_CODE: '',
}
